import React from "react";

//REDUX
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as reduxActions from "store/actions";
import reduxStore from "store";

//COMPONENTS
import Card from "components/Card";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Icon from "components/Icon";

//FUNCTIONS

import {
    loadCardsV2
} from "functions/loadData"

import { cardINNExists } from "functions/users"
import { translate } from "functions"

const InsightsBC = (props) => {
    const { search } = reduxStore.getState()
    const [page, setPage] = React.useState(0)
    const [limit] = React.useState(21)
    const [loading, setLoading] = React.useState(false)
    const [end, setEnd] = React.useState(false)

    const mounted = React.useRef(true)

    React.useEffect(() => {
        return () => {
            mounted.current = false
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const loadInsights = async (page, limit) => {
        if (mounted.current) {
            setLoading(true)
            let res = await loadCardsV2(props, {
                cardLoad: 'insights',
                limit: limit,
                skip: page * limit,
                ignoreLoader: true
            })
            if (res && mounted.current) {
                setLoading(false)
                if (res.total < limit)
                    setEnd(true)
            }
        }
    }

    React.useEffect(() => {
        if (!loading && !end && mounted.current)
            loadInsights(page, limit)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, limit])

    let hashs = window.location.hash.split('/')
    hashs[0] = hashs[0].replace('#', '')


    const db = reduxStore.getState().db

    let radarCards = Object.keys(db.cards)
        .filter(a =>
            db.cards[a]
            && db.cards[a].type === 'insight'
            && !db.cards[a].deleted
            && cardINNExists(a)
        )
        .sort((a, b) => {
            if (db.cards[a].created_at > db.cards[b].created_at)
                return -1
            if (db.cards[a].created_at < db.cards[b].created_at)
                return 1
            return 0
        })
        .map(a => db.cards[a])


    radarCards = radarCards.filter(a =>
    ((a.description && a.description.toLowerCase().indexOf(search.text.toLowerCase()) > -1)
        || (a.name && a.name.toLowerCase().indexOf(search.text.toLowerCase()) > -1)
    )).map(a => a)

    if (search.tags.length > 0)
        radarCards = radarCards.filter(fil =>
            fil._tags && fil._tags.length > 0 && fil._tags.filter(tag => {
                let result = false
                search.tags.forEach(tagFilter => {
                    if (tagFilter.value === tag.value)
                        result = true
                })
                return result
            }
            ).length > 0
        ).map(res => res)

    const scrollFunction = (e) => {
        var scrollDiv = document.getElementById(`insightList`);
        if (scrollDiv.scrollTop + window.innerHeight + 150 > scrollDiv.scrollHeight && mounted.current)
            setPage(page + 1)
    }

    if (radarCards
        .filter((i, ii) => (!props.max || (props.max && ii < props.max))).length === 0)
        return (
            <div
                id={"insightList"}
                style={!props.horizontal ? {
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: "flex",
                    overflowY: "auto",

                } : { position: 'relative', justifyContent: 'space-between', margin: 'auto', width: '100%' }}
                onScroll={!props.horizontal ? (e) => {
                    scrollFunction(e)
                } : null}
            >
                <GridContainer
                    style={{
                        ...props.horizontal ? {
                            overflowX: "auto",
                            flexFlow: "row",
                            display: "-webkit-inline-box"
                        } : {}
                    }}
                >
                    <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                    >
                        <div
                            style={{
                                justifyContent: "center",
                                textAlign: "center",
                                display: "block", paddingBottom: 15
                            }}
                        >
                            <div style={{ margin: "auto", marginBottom: 15, display: "flex", justifyContent: "center" }}><Icon size={"33px"} icon={"info"} color={"lightblue"} /></div>
                            <div style={{ color: "lightgray", fontSize: 33, texAlign: "center", marginBottom: 15 }}>{translate("$__youHaveNoIdeasAddedYet")}</div>
                            <div style={{ color: "lightgray", fontSize: 18, texAlign: "center", marginBottom: 15 }}>{translate("$__visitLinkToHowGetStarted")}</div>
                            <a href="https://support.machen.ai/manual/bright-connected/radar/" target="_blank" rel="noopener noreferrer" style={{ fontSize: 18, color: "blue", texAlign: "center", }}>{translate("$__getStarted")}</a>

                        </div>
                    </GridItem>
                </GridContainer>
            </div>
        )

    return (
        <div
            id={"insightList"}
            style={!props.horizontal ? {
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                overflowY: "auto",

            } : { position: 'relative', justifyContent: 'space-between', margin: 'auto', width: '100%' }}
            onScroll={!props.horizontal ? (e) => {
                scrollFunction(e)
            } : null}
        >
            <GridContainer
                style={{
                    ...props.horizontal ? {
                        overflowX: "auto",
                        flexFlow: "row",
                        display: "-webkit-inline-box"
                    } : {}
                }}
            >
                {Object.keys(radarCards)
                    .filter((i, ii) => (!props.max || (props.max && ii < props.max)))
                    .map((card, i) => {
                        return (
                            <GridItem
                                key={radarCards[card]._id}
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                xl={2}
                            >
                                <Card db="cards" data={radarCards[card]} expanded Avatar Resume showConnectedIn LoadParent />
                            </GridItem>
                        )
                    })}
            </GridContainer>
        </div>
    )
}

const mapStateToProps = (store) => ({
    cards: store.db.cards,
    search: store.search,
    users: store.db.users
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(reduxActions, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InsightsBC)